<template>
  <v-card>
    <v-layout>

      <div  v-if="show_stations" style="width: 250px;">
        <v-list dense v-if="show_stations">
          <v-list-item-group
            v-model="current_station"
            color="success"
          >
            <v-subheader v-if="lab_stations.length > 0">Лабораторные приборы</v-subheader>
            <v-list-item
              v-for="st in lab_stations"
              :key="st.id"
              @click='station_type = 3, choose_station(st.id)'
              :color="current_station_id == st.id ? 'success' : 'primary'"
            >
              <!-- <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon> -->
              <v-list-item-content>
                <v-list-item-title v-text="st.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-subheader v-if="react_stations.length > 0">Реактор ИР-8</v-subheader>
            <v-list-item
              v-for="st in react_stations"
              :key="st.id"
              @click='station_type = 2, choose_station(st.id)'
              :color="current_station_id == st.id ? 'success' : 'primary'"
            >
              <!-- <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon> -->
              <v-list-item-content>
                <v-list-item-title v-text="st.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-subheader v-if="sinch_stations.length > 0">Синхротрон</v-subheader>
            <v-list-item
              v-for="st in sinch_stations"
              :key="st.id"
              :color="current_station_id == st.id ? 'success' : 'primary'"
              @click='station_type = 1, choose_station(st.id)'
            >
              <!-- <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon> -->
              <v-list-item-content>
                <v-list-item-title v-text="st.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>





        <div style='background-color:rgba(255, 255, 255); margin-left: auto; margin-right: auto; display: block;'>

          <div style="padding-right:30px;">
            <v-row>
              <v-col cols="4" class="pa-0 pt-1">
                <span>
                  <v-icon color="#e858ff">mdi-alarm-light-outline</v-icon>
                  пучок : {{workload_ms > 0 ? workload_ms : 0}} часов
                  <br />
                </span>
              </v-col>
              <v-col cols="4" class="pa-0 pt-1">
                <span>
                  <v-icon color="#15336D">mdi-alarm-check</v-icon>
                  заявки : {{workload_proposals > 0 ? workload_proposals : 0}} часов
                  <br />
                </span>
              </v-col>
              <v-col cols="4" class="pa-0 pt-1">
                <span>
                  <v-icon color="green">mdi-shield-home-outline</v-icon>
                  in-house : {{workload_inhouse > 0 ? workload_inhouse : 0}} часов
                  <br />
                </span>
              </v-col>
            </v-row>
            <v-row v-if="not_distributed_count > 0">
              <v-col cols="4" class="pa-0 pt-1">
              </v-col>
              <v-col cols="8" class="pa-0 pt-1">
                <span>
                  <v-icon color="red">mdi-alert-circle</v-icon>
                  не распределено заявок : {{ not_distributed_count }} на {{not_distributed > 0 ? not_distributed : 0}} часов
                  <br />
                </span>
              </v-col>
            </v-row>
          </div>

          <v-sheet
              style="padding: 0 15px;"
              tile
              height="54"
              
              class="d-flex align-center">
              

          <!-- <div style="height: 40px;"> -->
            <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="prev"
              >
                <v-icon small>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
          
            <v-btn
              outlined
              x-small
              :color="$mainColor"
              @click="to_today"
            >
              сегодня
            </v-btn>

            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="next"
            >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>

            <v-btn
              rounded
              color="primary"
              small
              style="margin-left: 100px; margin-right: 170px;"
            >
              {{ current_month }}
              {{ current_year }}
            </v-btn>

            <template v-for='filter_date in filters'>
              <v-btn
                  v-if='filter_date.slug===type_view'
                  class='ml-1'
                  x-small
                  :color="$mainColor"
                  style='color:white'
                  @click="change_vies(filter_date.slug)"
              >
                  {{filter_date.name}}
              </v-btn>

              <v-btn
                  v-else
                  outlined
                  class='ml-1'
                  x-small
                  :color="$mainColor"
                  @click="change_vies(filter_date.slug)"
              >
                  {{filter_date.name}}
              </v-btn>
            </template>
          <!-- </div> -->
            <v-btn
              v-if="is_moderator || is_react_admin || is_sinch_admin || is_lab_admin"
              fab
              text
              small
              color="grey darken-2"
              @click="add_ms"
            >
              <v-icon small>
                mdi-plus
              </v-icon>
            </v-btn>

          </v-sheet>
            
          <v-calendar
            style='height:600px; width:750px; background-color:rgba(250, 242, 160, 40%);'
            :now="today"
            :value="current_cal_date"
            :type='type_view'
            :event-color="getEventColor"
            :first-time="first_time"
            :locale="locale"
            :event-more=false
            :weekdays="weekdays"
            :events="events"
            @click:event="openPopupCard_d"
          >
          </v-calendar>

          <v-dialog v-if="popup_data.type != 3 && popup_data.type != 4"
          v-model="dialogCalendarCard"
          width="60%">
          <calendar-card
            @updateParent="update_parent($event)" 
            @closeModal="close_modal($event)" 
            :InputData="popup_data"
          />
          </v-dialog>

          <v-dialog  v-if="popup_data.type == 3 || popup_data.type == 4"
            v-model="dialogCalendarCard"
            width="360px"
          >
          <calendar-ms-card
            @updateParent="update_parent_ms($event)" 
            :InputData="popup_data"
            :add_new="is_add_new_ms"
          />

          </v-dialog>
        </div>
    
    </v-layout>
  </v-card>



</template>


<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import CalendarCard from '../Modal/CalendarCard.vue'
import CalendarMsCard from '../Modal/CalendarMSCard.vue'

  export default {
    props: {
      input_station_id: Number,
      need_show_calendar: Date,
    },
    data: () => ({
      calendar_date: null,
      current_month: '',
      current_year: '',
      current_cal_date: '2025-01-01',
      today: '2021-02-15',
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      first_time: "8:00",
      locale: "ru-ru",
      dialogCalendarCard: false,
      type_view: 'month',
      popup_data:{
        name:  null,
        currentStations: null,
        nameCard: null,
        listDate: null,
        comment: null,
        author: null,
        typeApp: null,
        idExperiment: null,
      },
      filters: [
          {name:'месяц',slug:'month'},
          {name:'неделя',slug:'week'},
          // {name:'4 дня',slug:'4day'}
      ],
      events: [],
      is_init: false,
      menus: [
        {name:'Общая статистика',id: 1, disabled:false, icon:'mdi-chart-pie'},
        {name:'Оперативные журналы',id: 2, disabled:true, icon:'mdi-clock-fast'},
      ],
      current_station_id: null,
      current_station: null,
      sinch_stations: [],
      react_stations: [],
      lab_stations: [],
      show_stations: false,
      ms_working_events: [],
      react_working_events: [],
      sinch_working_events: [],
      station_type: null,
      workload_proposals: 0,
      workload_inhouse: 0,
      workload_ms: 0,
      not_distributed: 0,
      not_distributed_count: 0,
      is_moderator: false,
      is_sinch_admin: false,
      is_react_admin: false,
      is_lab_admin: false,
      is_add_new_ms: false,
       
    }),

    async beforeMount() {
      this.calendar_date = new Date()
      this.update_curr()
      this.load_ms_calendar()

      this.calc_availiable_stations()
      if(this.input_station_id > 0){
        this.current_station_id = this.input_station_id
        if(this.GETTERS_CALENDAR_INIT){
          this.load_calendar()
        }
      }
    },

    components:{
      CalendarCard, CalendarMsCard
    },

    computed:{
        ...mapGetters([
          'GETTERS_STATION_CALENDAR',
          'GETTERS_CALENDAR_INIT',
          'GETTERS_CURRENT_STATION',
          'GETTERS_UPDATE_CURRENT_CALENDAR',
          'GETTERS_CURRENT_USER',
          'GETTERS_STATIONS',
          'GETTERS_STATION_BY_ID',
        ]),        
    },

    watch:{
      GETTERS_UPDATE_CURRENT_CALENDAR(val){
        if(val){
          this.load_calendar()
          this.UPDATE_CURRENT_CALENDAR(false)
        }
      },

      GETTERS_CURRENT_STATION(val){
        if(val){
          this.current_station_id = val
          this.load_calendar()
        }
      },

      GETTERS_CALENDAR_INIT(val) {
        if(val){
          this.load_calendar();
          this.calc_availiable_stations()
        }
      },

      need_show_calendar(val) {
        if(val > 0){
          this.show_calendar()
        }
      },

    },

    methods:{
      ...mapActions([ 
        'GET_CALENDAR_LIST',
        'GET_CALENDAR_MS_LIST',
        'GET_STATION_WORKLOAD',
      ]),
      ...mapMutations([
        'UPDATE_CURRENT_CALENDAR',
        'UPDATE_OVERLAY',
      ]),

      add_ms(){
        if((this.is_moderator || this.is_react_admin || this.is_sinch_admin || this.is_lab_admin) && this.current_station_id > 0){
          var event = {}
          if(this.station_type == 1){
            event = {
              name:  'пучок КИСИ' ,
              source: {
                start_date: null,
                finish_date: null
              },
              id: 0,
              type: 3,
            }
          }
          else if(this.station_type == 2){
            event = {
              name:  'пучок ИР-8' ,
              source: {
                start_date: null,
                finish_date: null
              },
              id: 0,
              type: 4,
            }
          }
          else{
            return
          }

          this.is_add_new_ms = true
          this.popup_data = event
          this.dialogCalendarCard =true
        }
      },

      load_ms_calendar(){
        this.sinch_working_events = []
        this.react_working_events = []
        this.GET_CALENDAR_MS_LIST()
        .then((res) => {
          res.data.forEach(event => {
            if(event.type == 3)
              this.sinch_working_events.push({
                name:  'пучок КИСИ' ,
                start: this.formate_date_for_cal(event.start_date, true),
                end: this.formate_date_for_cal(event.finish_date, false),
                source: event,
                id: event.id,
                type: event.type,
              })                  

            else if(event.type == 4)
              this.react_working_events.push({
                name:  'пучок ИP-8' ,
                start: this.formate_date_for_cal(event.start_date, true),
                end: this.formate_date_for_cal(event.finish_date, false),
                source: event,
                id: event.id,
                type: event.type,
              })                  
          })
          if(this.current_station_id > 0)
            this.choose_station(this.current_station_id)
        })
      },

      calc_availiable_stations(){
        var is_bs = false;
        var all_stations = this.GETTERS_STATIONS
        var cur_user = this.GETTERS_CURRENT_USER
        this.sinch_stations = []
        this.react_stations = []
        this.lab_stations = []

        cur_user.role.forEach(role => {
          if(role.id == 2)
            this.is_moderator = true
          else if(role.id == 4)
            is_bs = true
          else if(role.id == 5)
            cur_user.megascience.forEach(ms => {
              if(ms.id == 1)
                this.is_sinch_admin = true
              else if(ms.id == 2)
                this.is_react_admin = true
              else if(ms.id == 3)
                this.is_lab_admin = true
            })
        })
        if(!is_bs && !this.is_moderator && !this.is_react_admin && !this.is_sinch_admin && !this.is_lab_admin)
          return

        all_stations.forEach(station => {
          if(station['is_active']){
            if(station['megascience_type'] == 'synchrotron'){
              if(this.is_moderator || this.is_sinch_admin)
                this.sinch_stations.push(station)
              else if(is_bs){
                cur_user.station.forEach(user_station => {
                  if(user_station.id == station.id)
                  this.sinch_stations.push(station)
                })
              }

            }
            else if(station['megascience_type'] == 'reactor'){
              if(this.is_moderator || this.is_react_admin)
              this.react_stations.push(station)
              else if(is_bs){
                cur_user.station.forEach(user_station => {
                  if(user_station.id == station.id)
                  this.react_stations.push(station)
                })
              }
            }
            else if(station['megascience_type'] == 'lab'){
              if(this.is_moderator || this.is_lab_admin)
              this.lab_stations.push(station)
              else if(is_bs){
                cur_user.station.forEach(user_station => {
                  if(user_station.id == station.id)
                  this.lab_stations.push(station)
                })
              }
            }
          }
        })

        this.show_stations = (this.react_stations.length + this.sinch_stations.length + this.lab_stations.length) > 0
      },

      choose_station(id){
        this.current_station_id = id
        this.update_events()
        this.get_workload()
      },

      get_workload(){
        var d = this.calendar_date
        var mm = d.getMonth() + 1
        var yy = d.getFullYear()
        if(mm < 10)
          mm = '0' + mm.toString()

        var args = {
          station_id: this.current_station_id,
          start: yy + '-' + mm + '-01'
        }

        this.workload_proposals = 0
        this.workload_inhouse = 0
        this.workload_ms = 0
        this.not_distributed = 0
        this.not_distributed_count = 0

        this.GET_STATION_WORKLOAD(args)
        .then((res) => {
          this.workload_proposals = res.data.proposals/3600
          this.workload_inhouse = res.data.inhouse/3600
          this.workload_ms = res.data.ms_working_time/3600
          this.not_distributed = res.data.not_distributed
          this.not_distributed_count = res.data.not_distributed_count
        })
      },

      async load_calendar(){
        if(this.current_station_id > 0){
          this.GET_CALENDAR_LIST({station_id:this.current_station_id})
          .then(() => {
            this.update_events();
          })
        }
      },

      update_events(){
        if(this.current_station_id > 0){
          var res = this.GETTERS_STATION_CALENDAR(this.current_station_id);
          if(res.loaded){
            this.events = []
            if(this.station_type == 1){
              this.sinch_working_events.forEach(event => {
                this.events.push(event)
              })
            }
            else if(this.station_type == 2){
              this.react_working_events.forEach(event => {
                this.events.push(event)
              })
            }

            res.calendars.forEach(calendar_item => {
              var name = ''
              if(calendar_item.type == 2 || calendar_item.type == 5){
                name = calendar_item.proposal_id + ' ' + calendar_item.proposal_applicant
              }
              else{
                name = calendar_item.experiment_name ??  'без названия'
              }

              this.events.push({
                name:  name ,
                start: this.formate_date_for_cal(calendar_item.start_date, true),
                end: this.formate_date_for_cal(calendar_item.finish_date, false),
                source: calendar_item,
                id: calendar_item.id,
                type: calendar_item.type,
              })                  
            })
          }
          else{
            this.load_calendar()
          }
        }
      },

      formate_date_for_cal(str, with_one){
        var dd_cal = new Date(str)
        var min = dd_cal.getMinutes()
        if (min === 0 && with_one) min = '1'
        const formatted = `${dd_cal.getFullYear()}-${(dd_cal.getMonth()+1)}-${dd_cal.getDate()} ${dd_cal.getHours()}:${min}`
        return formatted
      },

      async openPopupCard_d({ nativeEvent, event }) {
        if((event.type == 3 || event.type == 4) && !this.is_react_admin && !this.is_lab_admin && !this.is_sinch_admin && !this.is_moderator)
          return;
        this.popup_data = event
        this.is_add_new_ms = false
        this.dialogCalendarCard =true
      },

      to_today(){
        this.calendar_date = new Date()
        this.update_curr()
      },

      getEventColor(event) {
          if (event.type == 0) // 'обслуживание станции'
            return '#00ffda'
          else if (event.type == 2)  // proposal
            return '#15336D'
          else if (event.type == 1) // 'in-house'
            return 'green'
          else if (event.type == 3) // пучок КИСИ
            return '#e858ff'
          else if (event.type == 4) // пучок ИP-8
            return '#e858ff'
          else if (event.type == 5)  // proposal draft
            return '#0fa7c8e6'
          else
            return  'red'
      },
      
      prev () {
        if(this.type_view == 'month'){
          this.calendar_date.setMonth(this.calendar_date.getMonth() - 1)
        }
        else if(this.type_view == 'week'){
          this.calendar_date.setDate(this.calendar_date.getDate() - 7)
        }

        this.update_curr()
      },
      
      next () {
        if(this.type_view == 'month'){
          this.calendar_date.setMonth(this.calendar_date.getMonth() + 1)
        }
        else if(this.type_view == 'week'){
          this.calendar_date.setDate(this.calendar_date.getDate() + 7)
        }

        this.update_curr()
      },
      
      update_curr(){
        var mm = this.calendar_date.getMonth() + 1;
        var dd = this.calendar_date.getDate();
        var yy = this.calendar_date.getFullYear();

        this.current_cal_date =  yy + '-' + mm + '-' + dd; //(US)

        var t = 'month.' + mm 
        this.current_month = this.$t(t)
        this.current_year = this.calendar_date.getFullYear();

        this.get_workload()
      },

      change_vies(type){
          this.type_view = type
      },

      show_calendar(){
        this.UPDATE_OVERLAY(true)

        if(!this.events){
          this.update_events()
            .then(() => {
              this.show_calendar();
            })
        }
        else
          this.UPDATE_OVERLAY(false)
      },

      update_parent() {
        this.load_calendar()
        this.dialogCalendarCard =false
      },

      update_parent_ms() {
        this.load_ms_calendar()
        this.dialogCalendarCard =false
      },

      close_modal(){
        this.dialogCalendarCard = false
      },
    },

    mounted () {
      var d = new Date()
      this.calendar_date = new Date()
      this.today = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    },
  }
</script>


<style scoped>
.v-event {
  height: 40px;
}
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
}
  
.my-event.with-time {
  position: absolute;
  right: 4px;
  margin-right: 0px;
}
  .btn-calendar-completed{
    background: #15336d;
    border-radius: 15px;
    color:white;
    padding: 15px 20px;
  }
</style>